import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { BranchYearDTO, IBranchYearDTO } from './branch.year.dto';
import { BranchYearJudgeRoundDTO, IBranchYearJudgeRoundDTO } from './branch.year.judge.round.dto';
import { IJudgeSpecialityDTO, JudgeSpecialityDTO } from './judge.specialty.dto';
import { ISubmissionRubricFormDTO, SubmissionRubricFormDTO } from './submission.rubric.dto';
import { IUserDTO, UserDTO } from './user.dto';

export interface IBranchYearJudgeDTO extends IBaseEntityDTO {
  judge: IUserDTO;
  branchYear: IBranchYearDTO;
  submissions: ISubmissionRubricFormDTO[];
  specialities: IJudgeSpecialityDTO[];
  roundAssignments: IBranchYearJudgeRoundDTO[];
}

export class BranchYearJudgeDTO extends BaseEntityDTO implements IBranchYearJudgeDTO {
  judge: IUserDTO;
  branchYear: IBranchYearDTO;
  submissions: ISubmissionRubricFormDTO[];
  specialities: IJudgeSpecialityDTO[];
  roundAssignments: IBranchYearJudgeRoundDTO[];
  constructor(data?: Partial<BranchYearJudgeDTO>) {
    super(data);
    this.judge = new UserDTO(data?.judge);
    this.branchYear = new BranchYearDTO(data?.branchYear);
    this.submissions = data?.submissions
      ? data.submissions.map((submission) => new SubmissionRubricFormDTO(submission))
      : [];
    this.specialities = data?.specialities
      ? data.specialities.map((specialty) => new JudgeSpecialityDTO(specialty))
      : [];
    this.roundAssignments = data?.roundAssignments
      ? data.roundAssignments.map((round) => new BranchYearJudgeRoundDTO(round))
      : [];
  }
}
